import { isRecordLike } from '../../../../helpers';
import type { Envelope } from '../../types';

export const isEnvelope = (value: unknown): value is Envelope => {
    // eslint-disable-next-line
    return (
        isRecordLike(value) &&
        'savedAt' in value &&
        typeof value.savedAt === 'number' &&
        'data' in value
    );
};
